const http="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/";
// 开幕寄语
const jsonData = [
    {
        "id": 13,
        "headPortrait": http+"image/or13.png",
        "name": "楚晨曦",
        "unit": "科园信海(北京)医疗用品贸易有限公司",
        "post": "总经理",
        "postInfo": "",
        "vId":"n3125sbei8c",
        "mediaUrl": http+"or13.mp4"
    },
    {
        "id": 5,
        "headPortrait": http+"image/or5.png",
        "name": "曾胜",
        "unit": "一力制药股份有限公司",
        "post": "董事长",
        "postInfo": "",
        "vId":"d312570adud",
        "mediaUrl": http+"or5.m4v"
    },
    {
        "id": 17,
        "headPortrait": http+"image/or17.png",
        "name": "陈璐",
        "unit": "香丹清云上药交会",
        "post": "负责人",
        "postInfo": "",
        "vId":"c3125zctiuu",
        "mediaUrl": http+"or17.mp4"
    },
    {
        "id": 12,
        "headPortrait": http+"image/or12.png",
        "name": "王鹏浩",
        "unit": "哈药集团",
        "post": "副总裁",
        "postInfo": "",
        "vId":"p3125f8kd8j",
        "mediaUrl": http+"or12.mp4"
    },
    {
        "id": 15,
        "headPortrait": http+"image/or15.png",
        "name": "胡庆峰",
        "unit": "神威药业",
        "post": "营销副总经理",
        "postInfo": "",
        "vId":"b3125gx52vf",
        "mediaUrl": http+"or15.m4v"
    },
    {
        "id": 19,
        "headPortrait": http+"image/or19.png",
        "name": "蒋云波",
        "unit": "曲焕章药业",
        "post": "总经理",
        "postInfo": "",
        "vId":"k3126kzcssc",
        "mediaUrl": http+"or19.mp4"
    },
    {
        "id": 8,
        "headPortrait": http+"image/or8.png",
        "name": "宋志奇",
        "unit": "马应龙药业集团",
        "post": "",
        "postInfo": "",
        "vId":"i3125xxo93c",
        "mediaUrl": http+"or8.mp4"
    },
    {
        "id": 9,
        "headPortrait": http+"image/or9.png",
        "name": "蒲建",
        "unit": "普利制药",
        "post": "",
        "postInfo": "",
        "vId":"c3125nm0d3m",
        "mediaUrl": http+"or9.mp4"
    },
    {
        "id": 1,
        "headPortrait": http+"image/or1.png",
        "name": "胡瑾瑜",
        "unit": "山西碧锦纳川医药有限公司",
        "post": "",
        "postInfo": "",
        "vId":"w3120kq8j3f",
        "mediaUrl": http+"or1.mp4"
    },
    {
        "id": 16,
        "headPortrait": http+"image/or16.png",
        "name": "张朝辉",
        "unit": "石药集团欧意和销售公司",
        "post": "总经理",
        "postInfo": "",
        "vId":"a3125057zqj",
        "mediaUrl": http+"or16.mp4"
    },
    {
        "id": 6,
        "headPortrait": http+"image/or6.png",
        "name": "刘凤",
        "unit": "必康润祥",
        "post": "副总经理",
        "postInfo": "",
        "vId":"k31251dimup",
        "mediaUrl": http+"or6.mp4"
    },
    {
        "id": 11,
        "headPortrait": http+"image/or11.png",
        "name": "陈树凡",
        "unit": "达美医药",
        "post": "董事长",
        "postInfo": "",
        "vId":"y3125oh33uk",
        "mediaUrl": http+"or11.mp4"
    },
    {
        "id": 3,
        "headPortrait": http+"image/or3.png",
        "name": "李军斌",
        "unit": "山西天士力康美徕医药有限公司",
        "post": "总经理",
        "postInfo": "",
        "vId":"e3120lyl1yy",
        "mediaUrl": http+"or3.mp4"
    },
    {
        "id": 2,
        "headPortrait": http+"image/or2.png",
        "name": "张继顺",
        "unit": "山西乐群医药有限公司",
        "post": "董事长",
        "postInfo": "",
        "vId":"r31203c548w",
        "mediaUrl": http+"or2.mp4"
    },
    {
        "id": 7,
        "headPortrait": http+"image/or7.png",
        "name": "杨静霞",
        "unit": "河北美康太平医药贸易有限公司",
        "post": "董事长",
        "postInfo": "",
        "vId":"e3125o1dhgb",
        "mediaUrl": http+"or7.mp4"
    },
    {
        "id": 14,
        "headPortrait": http+"image/or14.png",
        "name": "任晓东",
        "unit": "山西亚宝医药物流配送有限公司",
        "post": "总经理",
        "postInfo": "",
        "vId":"v3125tw2mgx",
        "mediaUrl": http+"or14.mp4"
    },
    {
        "id": 4,
        "headPortrait": http+"image/or4.png",
        "name": "刘中雷",
        "unit": "长春市世纪天翼医药有限公司",
        "post": "销售部经理",
        "postInfo": "",
        "vId":"k31207299o7",
        "mediaUrl": http+"or4.mp4"
    },
    {
        "id": 10,
        "headPortrait": http+"image/or10.png",
        "name": "段国静",
        "unit": "中诚康宇医药",
        "post": "总经理",
        "postInfo": "",
        "vId":"v3125sfj93d",
        "mediaUrl": http+"or10.mp4"
    },
    {
        "id": 18,
        "headPortrait": http+"image/or18.png",
        "name": "梁华权",
        "unit": "肇庆市新辉药",
        "post": "总经理",
        "postInfo": "",
        "vId":"w3125jb9nxf",
        "mediaUrl": http+"or18.mp4"
    },
    {
        "id": 20,
        "headPortrait": http+"image/or20.png",
        "name": "杨江林",
        "unit": "曼迪新",
        "post": "",
        "postInfo": "",
        "vId":"u31268vx4zu",
        "mediaUrl": http+"or20.mp4"
    },
    {
        "id": 21,
        "headPortrait": http+"image/or21.png",
        "name": "晋冬",
        "unit": "曲焕章药业",
        "post": "营销总监",
        "postInfo": "",
        "vId":"q3126jbadu4",
        "mediaUrl": http+"or21.mp4"
    }
]
// 行业分享
const vData=[
    [//店员培训 0
        {
            "id":'0-0',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'哮喘及用药'
        },
        {
            "id":'0-1',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'肺炎及用药'
        },
        {
            "id":'0-2',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'感冒及用药'
        },
        {
            "id":'0-3',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'腹泻及用药'
        },
        {
            "id":'0-4',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'便秘及用药'
        },
        {
            "id":'0-5',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'慢性胃炎及用药'
        },
        {
            "id":'0-6',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'小二急性上呼吸道感染、感冒'
        },
        {
            "id":'0-7',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'急性支气管炎、咳嗽/小儿哮喘'
        },
        {
            "id":'0-8',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'急性支气管炎、咳嗽/小儿哮喘'
        },
        {
            "id":'0-9',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'小儿腹泻'
        },
        {
            "id":'0-10',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'小儿湿疹'
        },
        {
            "id":'0-11',
            "headPortrait": "",
            "name": "李红炜",
            "unit": "法默西管理咨询",
            "post": "专业学术培训中心主任/高级顾问",
            "postInfo": "出身中医世家，家学渊源。黑龙江中医药大学中医系毕业，熟读《黄帝内经》、《伤寒论》等中医古典著作，拥有深厚的中医药理论知识。",
            "mediaUrl": "",
            "course":'小儿肺炎'
        },
        
        {
            "id":'0-12',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"5.mp4",
            "vId":"g31203o33nx",
            "course":'执业药师课程-病史采集-发热'
        },
        {
            "id":'0-13',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"6.mp4",
            "vId":"t3120gtri6b",
            "course":'执业药师课程-病史采集-皮肤黏膜出血'
        },
        {
            "id":'0-14',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"2.mp4",
            "vId":"x31209kbspb",
            "course":'执业药师课程-病例分析-呼吸系统疾病'
        },
        {
            "id":'0-15',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"1.mp4",
            "vId":"p31204w3xjn",
            "course":'执业药师课程-病例分析-循环系统疾病'
        },
        {
            "id":'0-16',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"4.mp4",
            "vId":"v3120vn740h",
            "course":'执业药师课程-病例分析-消化系统疾病'
        },
        {
            "id":'0-17',
            "headPortrait": "",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业药师课程-病例分析-儿科疾病'
        },
        {
            "id":'0-18',
            "headPortrait": http+"image/昭昭老师.png",
            "name": "昭昭老师",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": http+"3.mp4",
            "vId":"h3120lrv66w",
            "course":'执业药师课程-病例分析-泌尿系统疾病'
        },
        {
            "id":'0-19',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病史采集-发热'
        },
        {
            "id":'0-20',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病史采集-皮肤黏膜出血'
        },
        {
            "id":'0-21',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病例分析-呼吸系统疾病'
        },
        {
            "id":'0-22',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病例分析-循环系统疾病'
        },
        {
            "id":'0-23',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病例分析-消化系统疾病'
        },
        {
            "id":'0-24',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病例分析-儿科疾病'
        },
        {
            "id":'0-25',
            "headPortrait": "",
            "name": "刘钊",
            "unit": "昭昭教育",
            "post": "创始人",
            "postInfo": "中国医学考试培训青年领军人物，被广大学员誉为京城四大名师、医考之王等。授课风格鲜明生动，轻松理解、简单易记、押题精准，在国内首创“画图记忆法”，近年来经其培训并通过医考的学员数以万计，获得广大考生的一致认可。",
            "mediaUrl": "",
            "course":'执业医师课程-病例分析-泌尿系统疾病'
        },
        {
            "id":'0-26',
            "headPortrait": http+"image/李闯.jpg",
            "name": "李闯",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-26.mp4",
            "course":'辛温解表药-桂枝、紫苏（17分钟）',
            "vId":'w3128na4hg2'
        },
        {
            "id":'0-27',
            "headPortrait": http+"image/李闯.jpg",
            "name": "李闯",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-27.mp4",
            "course":'辛温解表药-麻黄（15分钟）',
            "vId":''
        },
        {
            "id":'0-28',
            "headPortrait": http+"image/李闯.jpg",
            "name": "李闯",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-28.mp4",
            "course":'辛温解表药-羌活、细辛（14分钟）',
            "vId":'b31286gzoqr'
        },
        {
            "id":'0-29',
            "headPortrait": http+"image/姜雅.jpg",
            "name": "姜雅",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-29.mp4",
            "course":'药一 药物与药物制剂01（17分钟）',
            "vId":'k3128vmrqkp'
        },
        {
            "id":'0-30',
            "headPortrait": http+"image/姜雅.jpg",
            "name": "姜雅",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-30.mp4",
            "course":'中药配伍与方剂（15分钟）',
            "vId":'c3128tpsvar'
        },
        {
            "id":'0-31',
            "headPortrait": http+"image/姜雅.jpg",
            "name": "姜雅",
            "unit": "昭昭教育",
            "post": "培训讲师",
            "postInfo": "",
            "mediaUrl": http+"0-31.mp4",
            "course":'中药药品标准（18分钟）',
            "vId":'u3128idrowy'
        }
    ],
    [
        //连锁管理 1
        {
            "id":'1-1',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-1.mp4",
            "course":'法默西店内例行工作与人员分工'
        },
        {
            "id":'1-2',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-2.mp4",
            "course":'门店人员如何做好店内写作'
        },
        {
            "id":'1-3',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-3.mp4",
            "course":'门店内部沟通与协调机制'
        },
        {
            "id":'1-4',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-4.mp4",
            "course":'如何做好商品效期管理防止效期损耗'
        },
        {
            "id":'1-5',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-5.mp4",
            "course":'如何通过盘点制度做好门店存货管理?'
        },
        {
            "id":'1-6',
            "headPortrait": http+"image/尹东宇.jpg",
            "name": "尹东宇",
            "unit": "法默西管理咨询总顾问",
            "post": "",
            "postInfo": "",
            "mediaUrl": http+"1-6.mp4",
            "course":'价格战我们到底打还是不打？',
            "vid": 't3128iimqpd',
        },
        {
            "id":'1-7',
            "headPortrait": "",
            "name": "尹东宇",
            "unit": "力美康医药科技 总经理，步长制药 药店渠道战略及营销顾问",
            "post": "法默西管理咨询总顾问，国家药监局高级研修学员 特聘专家讲师多家证券公司及投行基金 医药行业专家顾问",
            "postInfo": "",
            "mediaUrl": "",
            "course":'药店私域流量的转化变现与价值延伸'
        },
        {
            "id":'1-8',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'以发展规划和经营计划指引企业持续成长'
        },
        {
            "id":'1-9',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'如何建立完整的商采经营体系 打造强大盈利能力'
        },
        {
            "id":'1-10',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'如何通过科学的门店管理提升门店的终端竞争力'
        },
        {
            "id":'1-11',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'如何把慢病客流迅速转化为盈利增长点'
        },
        {
            "id":'1-12',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店商圈管理与商圈竞争策略'
        },
        {
            "id":'1-13',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店人员管理与效率提升'
        },
        {
            "id":'1-14',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店商品的常规管理与商品组合策略'
        },
        {
            "id":'1-15',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店数据分析与经营诊断'
        },
        {
            "id":'1-16',
            "headPortrait": "",
            "name": "刘文锋",
            "unit": " 曾任：广东清远百姓大药房医药连锁有限公司 常务副总经理 广东大参林医药连锁有限公司  分公司经理",
            "post": "法默西管理咨询副总经理/资深顾问 ",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店数据分析与经营诊断'
        },
        {
            "id":'1-17',
            "headPortrait": "",
            "name": "尹东宇",
            "unit": "力美康医药科技 总经理，步长制药 药店渠道战略及营销顾问",
            "post": "法默西管理咨询总顾问，国家药监局高级研修学员 特聘专家讲师多家证券公司及投行基金 医药行业专家顾问",
            "postInfo": "",
            "mediaUrl": "",
            "course":'商品规划与商品营销＆采购管理与存货管理'
        },
        {
            "id":'1-18',
            "headPortrait": "",
            "name": "尹东宇",
            "unit": "力美康医药科技 总经理，步长制药 药店渠道战略及营销顾问",
            "post": "法默西管理咨询总顾问，国家药监局高级研修学员 特聘专家讲师多家证券公司及投行基金 医药行业专家顾问",
            "postInfo": "",
            "mediaUrl": "",
            "course":'打造强大营运管理体系支持门店持续成长'
        },
        {
            "id":'1-19',
            "headPortrait": "",
            "name": "尹东宇",
            "unit": "力美康医药科技 总经理，步长制药 药店渠道战略及营销顾问",
            "post": "法默西管理咨询总顾问，国家药监局高级研修学员 特聘专家讲师多家证券公司及投行基金 医药行业专家顾问",
            "postInfo": "",
            "mediaUrl": "",
            "course":'连锁药店组织发展战略与人力资源管理'
        },
        {
            "id":'1-20',
            "headPortrait": "",
            "name": "尹东宇",
            "unit": "力美康医药科技 总经理，步长制药 药店渠道战略及营销顾问",
            "post": "法默西管理咨询总顾问，国家药监局高级研修学员 特聘专家讲师多家证券公司及投行基金 医药行业专家顾问",
            "postInfo": "",
            "mediaUrl": "",
            "course":'门店全套经营管理实战技术特训营'
        },
        {
            "id":'1-26',
            "headPortrait": http+"image/翟景怡.png",
            "name": "翟景怡",
            "unit": "法默西管理咨询",
            "post": "总经理/资深顾问",
            "postInfo": "拥有16年的医药行业从业经验，曾就职于制药企业、医药批发公司，后在北京投资开办万民阳光连锁药店，在经营实践总结了先进的、系统化的人力资源管理体系，在组织发展、宽带薪酬、绩效考核、识人用人、团队激励等方面拥有丰富的实战经验。在经营连锁药店的过程中为了提升服务质量与服务形象，翟景怡老师曾拜访多位知名礼仪专家，系统的学习服务礼仪、商务礼仪、国学礼仪知识，结合十余年连锁药店的管理经验，总结出针对连锁药店一线门店人员的顾客接待标准流程与服务礼仪的培训课程，课程内容简洁、有效、易复制，并在多家连锁药房进行实践，帮助合作连锁企业提升员工素质、打造与众不同的购物体验，创造出良好的品牌与服务形象，受到合作企业的一致好评。",
            "mediaUrl": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/0-1.mp4",
            "vId":"l3120phowqw",
            "course":'第一节 引言，药店为什么要建立标准化接待流程？'
        },
        {
            "id":'1-27',
            "headPortrait": http+"image/翟景怡.png",
            "name": "翟景怡",
            "unit": "法默西管理咨询",
            "post": "总经理/资深顾问",
            "postInfo": "拥有16年的医药行业从业经验，曾就职于制药企业、医药批发公司，后在北京投资开办万民阳光连锁药店，在经营实践总结了先进的、系统化的人力资源管理体系，在组织发展、宽带薪酬、绩效考核、识人用人、团队激励等方面拥有丰富的实战经验。在经营连锁药店的过程中为了提升服务质量与服务形象，翟景怡老师曾拜访多位知名礼仪专家，系统的学习服务礼仪、商务礼仪、国学礼仪知识，结合十余年连锁药店的管理经验，总结出针对连锁药店一线门店人员的顾客接待标准流程与服务礼仪的培训课程，课程内容简洁、有效、易复制，并在多家连锁药房进行实践，帮助合作连锁企业提升员工素质、打造与众不同的购物体验，创造出良好的品牌与服务形象，受到合作企业的一致好评。",
            "mediaUrl": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/0-2.mp4",
            "vId":"e31207aylhq",
            "course":'第二节 迎接顾客前的门店准备工作有哪些？（上）'
        },
        {
            "id":'1-28',
            "headPortrait": http+"image/翟景怡.png",
            "name": "翟景怡",
            "unit": "法默西管理咨询",
            "post": "总经理/资深顾问",
            "postInfo": "拥有16年的医药行业从业经验，曾就职于制药企业、医药批发公司，后在北京投资开办万民阳光连锁药店，在经营实践总结了先进的、系统化的人力资源管理体系，在组织发展、宽带薪酬、绩效考核、识人用人、团队激励等方面拥有丰富的实战经验。在经营连锁药店的过程中为了提升服务质量与服务形象，翟景怡老师曾拜访多位知名礼仪专家，系统的学习服务礼仪、商务礼仪、国学礼仪知识，结合十余年连锁药店的管理经验，总结出针对连锁药店一线门店人员的顾客接待标准流程与服务礼仪的培训课程，课程内容简洁、有效、易复制，并在多家连锁药房进行实践，帮助合作连锁企业提升员工素质、打造与众不同的购物体验，创造出良好的品牌与服务形象，受到合作企业的一致好评。",
            "mediaUrl": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/0-3.mp4",
            "vId":"o31208ujh9p",
            "course":'第三节 迎接顾客前的门店准备工作有哪些？（下）'
        },
        {
            "id":'1-29',
            "headPortrait": http+"image/翟景怡.png",
            "name": "翟景怡",
            "unit": "法默西管理咨询",
            "post": "总经理/资深顾问",
            "postInfo": "拥有16年的医药行业从业经验，曾就职于制药企业、医药批发公司，后在北京投资开办万民阳光连锁药店，在经营实践总结了先进的、系统化的人力资源管理体系，在组织发展、宽带薪酬、绩效考核、识人用人、团队激励等方面拥有丰富的实战经验。在经营连锁药店的过程中为了提升服务质量与服务形象，翟景怡老师曾拜访多位知名礼仪专家，系统的学习服务礼仪、商务礼仪、国学礼仪知识，结合十余年连锁药店的管理经验，总结出针对连锁药店一线门店人员的顾客接待标准流程与服务礼仪的培训课程，课程内容简洁、有效、易复制，并在多家连锁药房进行实践，帮助合作连锁企业提升员工素质、打造与众不同的购物体验，创造出良好的品牌与服务形象，受到合作企业的一致好评。",
            "mediaUrl": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/0-4.mp4",
            "vId":"t3120jjyw50",
            "course":'第四节 如何用正确的方式开启顾客接待？'
        },
        {
            "id":'1-30',
            "headPortrait": http+"image/翟景怡.png",
            "name": "翟景怡",
            "unit": "法默西管理咨询",
            "post": "总经理/资深顾问",
            "postInfo": "拥有16年的医药行业从业经验，曾就职于制药企业、医药批发公司，后在北京投资开办万民阳光连锁药店，在经营实践总结了先进的、系统化的人力资源管理体系，在组织发展、宽带薪酬、绩效考核、识人用人、团队激励等方面拥有丰富的实战经验。在经营连锁药店的过程中为了提升服务质量与服务形象，翟景怡老师曾拜访多位知名礼仪专家，系统的学习服务礼仪、商务礼仪、国学礼仪知识，结合十余年连锁药店的管理经验，总结出针对连锁药店一线门店人员的顾客接待标准流程与服务礼仪的培训课程，课程内容简洁、有效、易复制，并在多家连锁药房进行实践，帮助合作连锁企业提升员工素质、打造与众不同的购物体验，创造出良好的品牌与服务形象，受到合作企业的一致好评。",
            "mediaUrl": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_video/0-5.mp4",
            "vId":"r31200jj10q",
            "course":'第五节 在销售过程中，如何为顾客提供有效的专业导购？'
        }
    ],
    [//关于JDH
        {
            "id":'2-0',
            "headPortrait": http+"image/1.jpg",
            "name": "药京采",
            "unit": "药京采",
            "post": "京东健康医药批发平台",
            "postInfo": "",
            "mediaUrl": http+"7.mp4",
            "vId":'p3120wzno1w',
            "course":'京东健康药京采'
        },
        {
            "id":'2-0',
            "headPortrait": "",
            "name": "于佳",
            "unit": "京东健康互联网医疗",
            "post": "拓展经理",
            "postInfo": "",
            "mediaUrl": "",
            "course":'京东健康互联网医院'
        },
        {
            "id":'2-0',
            "headPortrait": "",
            "name": "李伟",
            "unit": "京东健康渠道创新药店",
            "post": "赋能部负责人",
            "postInfo": "",
            "mediaUrl": "",
            "course":'京东健康联盟药房'
        },
        {
            "id":'2-0',
            "headPortrait": "",
            "name": "朱君",
            "unit": "京东健康医药部",
            "post": "拓展经理",
            "postInfo": "",
            "mediaUrl": "",
            "course":'京东大药房'
        },
        {
            "id":'2-0',
            "headPortrait": "",
            "name": "待定",
            "unit": "",
            "post": "",
            "postInfo": "",
            "mediaUrl": "",
            "course":'京东健康消费医疗'
        },
        {
            "id":'2-0',
            "headPortrait": "",
            "name": "待定",
            "unit": "",
            "post": "",
            "postInfo": "",
            "mediaUrl": "",
            "course":'京东健康智慧医疗'
        }
    ],
    [
        //名医访谈
        {
            "id":'3-0',
            "headPortrait": "",
            "name": "李莉",
            "unit": "国家儿童医学中心，首都医科大学附属北京儿童医院",
            "post": "眼科主任",
            "postInfo": "国家儿童医学中心，首都医科大学附属北京儿童医院 眼科主任 中华医学会眼科学分会眼视光学组委员 中国医师协会青春期分会眼保健学组组长 中国医师协会眼科分会儿童眼健康学组副组长  中国医师协会眼科科普专业委员会委员 北京医师协会眼科分会小儿眼科学组组长 北京医学会眼科分会常务委员 北京市卫生健康委员会健康科普专家 《中华眼科杂志》编委 《中国斜视与小儿眼科杂志》编委",
            "mediaUrl": "",
            "course":'《儿童如何做好视力防控》'
        },
        {
            "id":'3-1',
            "headPortrait": "",
            "name": "温春玲",
            "unit": "北京妇产医院 新生儿科 ",
            "post": " 新生儿科  副主任医师",
            "postInfo": "硕士研究生。从事儿科临床、教学、科研工作近20年，目前在北京医学会早产及早产儿医学分会任青年委员。",
            "mediaUrl": "",
            "course":'手足口病防治和发热的正确处理'
        },
        {
            "id":'3-2',
            "headPortrait": "",
            "name": "卢颖州",
            "unit": "首都医科大学附属复兴医院",
            "post": "产科主任医师",
            "postInfo":'',
            "mediaUrl": "",
            "course":'孕期每个阶段该补充哪些营养'
        },
        {
            "id":'3-3',
            "headPortrait": "",
            "name": "李率",
            "unit": "北京大学口腔医院",
            "post": "副主任医师",
            "postInfo":'副主任医师，专业获奖情况：（近三年） 2013年CDS第三届全国青年口腔医师种植病例大赛一等奖（最高奖） 2013年第二届BITC口腔种植病例大奖赛二等奖 2012年第一届BITC口腔种植病例大奖赛二等奖（最高奖） 2012年CDS第二届全国青年口腔医师种植病例大赛二等奖 2011年CDS第一届全国青年口腔医师种植病例大赛一等奖（最高奖，合作医生陈波） 学术活动（学术著作）',
            "mediaUrl": "",
            "course":'关于种植牙您所不知道的一切'
        },
        {
            "id":'3-4',
            "headPortrait": "",
            "name": "王亚军",
            "unit": "首都儿科研究所儿童医院",
            "post": "副主任医师",
            "postInfo":'儿童过敏性疾病，如：过敏性哮喘，过敏性鼻炎，过敏性咳嗽',
            "mediaUrl": "",
            "course":'过敏性鼻炎来袭， 你怎么办？'
        },
        {
            "id":'3-5',
            "headPortrait": http+"image/罗平.jpg",
            "name": "罗平",
            "unit": "首都医科大学附属北京安贞医院",
            "post": "副主任医师",
            "postInfo":'1983年毕业于首都医科大学，任北京安贞医院急诊科急诊重症监护室主任，副主任医师。从事糖尿病工作30余年，在治疗糖尿病有独特的经验，在高血压病，心衰，冠心病等诊断治疗亦有丰富的经验。',
            "mediaUrl": http+"3-5.mkv",
            "course":'聊聊2型糖尿病'
        },
        {
            "id":'3-6',
            "headPortrait": "",
            "name": "蔺宏伟",
            "unit": "北京清华长庚医院",
            "post": " 普外科副主任医师",
            "postInfo":'中国医学科学院博士毕业，胃肠道肿瘤外科专业，北京大学医学部普外科博士后',
            "mediaUrl": "",
            "course":'病态性肥胖和二型糖尿病如何通过手术治疗'
        },
        {
            "id":'3-7',
            "headPortrait": "",
            "name": "闫春梅",
            "unit": "首都医科大学附属北京儿童医院",
            "post": "  副主任医师",
            "postInfo":'1989年开始从事儿内科临床工作至今。专业：儿内科，青春期心理和生长发育。2000年在全国率先成立青春期门诊。主要从事青春期生长发育和心理问题的临床门诊咨询、研究以及教学工作。针对青春期阶段的身体和心理问题进行咨询、分析、研究。学术期刊、学会、协会任职 1. 中国医院协会第二届医疗法制专业委员会委员。(2012年) 2.中华医学会健康管理学分会青年委员。(2011年) 3.中国医师协会儿童健康专业委员会青春期医学学组委员。(2013年) 4.北京卫生法学会患者安全委员会委员(2013年) 5.西城医学会医疗管理学组委员(2012年) 6.心理学会北京市分会会员。(2011年) 7. 青少年网络协会会员。(2011年) 8. 北京医学会鉴定专家(2013年) 9. 参加“医院中层管理领导力培训班”培训(2013年) 10. 获得中国医师人文医学职业技能师资培训证书(2013年)',
            "mediaUrl": "",
            "course":'孩子厌学家长该怎么办'
        },
        {
            "id":'3-8',
            "headPortrait": "",
            "name": "李偲圆",
            "unit": "主治医生",
            "post": "主治医生",
            "postInfo":'医学博士，擅长各类常见小儿眼科疾病诊治，儿童屈光不正、斜视、常见眼底病诊治。',
            "mediaUrl": "",
            "course":'小朋友近视了要一直戴眼镜嘛'
        },
        {
            "id":'3-9',
            "headPortrait": "",
            "name": "李继鹏",
            "unit": "首都医科大学附属北京同仁医院",
            "post": "副主任医师",
            "postInfo":'同仁眼科副主任医师，医学博士，留学英国。常见眼底疾病的手术和药物、激光治疗',
            "mediaUrl": "",
            "course":'中老年人常见眼底病的科普'
        },
        {
            "id":'3-10',
            "headPortrait": "",
            "name": "崔明",
            "unit": "北京大学肿瘤医院",
            "post": "胃肠肿瘤中心主任医师",
            "postInfo":'主任医师，副教授，硕士研究生导师，现担任“中华医学会外科学分会第十八届委员会”全国青年委员',
            "mediaUrl": "",
            "course":'专家谈不可忽视的胃癌预警信号'
        },
        {
            "id":'3-11',
            "headPortrait": "",
            "name": "高思华",
            "unit": "国家973计划中医药专项",
            "post": "首席科学家",
            "postInfo":'原北京中医药大学校长、中国中医研究院研究生部主任、教授、中医内科学博士生导师、中国中医研究院学术委员会委员、中国中医研究院学位评定委员会兼秘书长。',
            "mediaUrl": "",
            "course":'如何从肝脾肾同调来辩证治疗糖尿病？'
        },
        {
            "id":'3-12',
            "headPortrait": "",
            "name": "陈宝贵",
            "unit": "天津中医药大学",
            "post": "教授、博士生导师，天津中医药大学附属武清中医院名誉院长",
            "postInfo":'首届全国名中医，天津中医药大学教授、博士生导师，中国中医科学院传承博士后合作导师，享受国务院特殊津贴专家，全国老中医药专家学术经验继承工作指导老师。',
            "mediaUrl": "",
            "course":'脾胃功能的重建与调理'
        },
        {
            "id":'3-13',
            "headPortrait": "",
            "name": "张昶",
            "unit": "航天中心医院",
            "post": "主任医师",
            "postInfo":'北京中医药大学博士、主任医师、医学科普专家从事中医内科和骨伤疼痛临床与教学十余年。在针刀针灸手法上独树一帜，尤其对脊柱关节病和慢性疼痛有显著疗效。累计诊治患者10万余人次，开展针刀治疗1万余例，培养针刀医师数百名，在业界享有良好口碑。在“今日头条”“有来健康”“搜狐健康”等媒体，开设“张昶博士中医讲堂”进行科普宣传，所发布科普文章访问量超2000万。先后获得医院金牌讲师、作民医学人才奖、建院60周年突出贡献奖等多个奖项。受到《北京卫视》《参考消息》《中央人民广播电台》《中国妇女报》及《中国航天报》等媒体的广泛报道。',
            "mediaUrl": "",
            "course":'夏季常吹空调，如何防护及调理颈肩病'
        },
        {
            "id":'3-14',
            "headPortrait": "",
            "name": "夏萌",
            "unit": "首都医科大学附属北京安贞医院",
            "post": "临床营养科原主任",
            "postInfo":'各种疾病的营养调整；大众营养；危重病人的营养支持。 神经内科各种常见病、疑难杂症的诊断及治疗；神经康复；精神心理治疗',
            "mediaUrl": "",
            "course":'营养在健康管理中的作用'
        },
        {
            "id":'3-15',
            "headPortrait": "",
            "name": "俞丽丽",
            "unit": "重庆医科大学附属第三医院 产科",
            "post": "主任医师、教授",
            "postInfo":'中国中西医结合学会第十届妇产科专业委员会委员 中国医药教育协会专家委员会医学专家库专家 中国医药教育协会母婴健康管理专业委员会委员 中国医药教育协会生殖内分泌专业委员会更年期教育培训中心委员 中国医师协会第二届委员会产科科普专业委员会委员 中国医疗保健国际交流促进会围产与营养代谢学分会委员 全国妊娠期高血压疾病学组青年委员第二届中国女医师协会妇产科专业委员会委员 中国女医师协会医体专业委员会第一届委员会常务委员 重庆市医学会第五届围产医学专业委员会副主任委员、危重产科学组副组长 重庆医学会妇产科专委会妇科内分泌及计划生育学组委员 重庆妇幼保健协会慢性疾病管理专业委员会常委 中国孕婴协会孕期瑜伽导师 重庆市妇幼卫生学会“生育舞蹈和孕产瑜伽示范基地”主任 重庆市医师协会风湿免疫科医师分会第一届委员会免疫相关生殖疾病学组副组长 重庆市老年学和老年医学学会老年慢病管理分会第一届委员重庆市康复医学会产后康复专业委员会委员',
            "mediaUrl": "",
            "course":'专家指导孕期的正确运动'
        },
        {
            "id":'3-16',
            "headPortrait": "",
            "name": "马良坤",
            "unit": "北京协和医院妇产科",
            "post": "主任医师",
            "postInfo":'北京协和医院妇产科主任医师，中国医师协会医学科普分会产科科普专委会主任委员，中国医药教育协会母婴健康管理专业委员会主任委员',
            "mediaUrl": "",
            "course":'让我们一起学习，做个好妈妈'
        },
        {
            "id":'3-17',
            "headPortrait": "",
            "name": "梅长林",
            "unit": "解放军肾脏病研究所所长",
            "post": "著名肾脏病专家 ",
            "postInfo":'国内知名专家，海军军医大学附属上海长征医院，享受国务院政府特殊津贴，获得多项重要发明专利及医疗成果奖项。',
            "mediaUrl": "",
            "course":'慢性肾脏病预防及管理'
        },
        {
            "id":'3-18',
            "headPortrait": "",
            "name": "邬碧波",
            "unit": "上海市静安区医学会肾脏病学组秘书 上海市静安区肾内科专业质控组秘书",
            "post": "主任医师 第二军医大学医学硕士，澳大利亚Flinders University医院管理硕士",
            "postInfo":'上海市静安区闸北中心医院肾内科副主任，血透室主任，从事肾脏病临床和科研工作20年，对各种肾脏病的诊断及治疗有丰富的临床经验，擅长各种原发性和继发性肾病，特别是常见肾脏损伤的诊断和治疗。',
            "mediaUrl": "",
            "course":'让"痛"随"风”去--专家告诉你诀窍'
        },
        {
            "id":'3-19',
            "headPortrait": "",
            "name": "陈步星",
            "unit": "北京中医药大学东直门医院 ",
            "post": "心血管内科 主任医师",
            "postInfo":'医学博士，主任医师, 教授，博士研究生导师。1984年福建医学院大学本科毕业，1996年北京医科大学（现北京大学医学部）博士毕业，荣获医学博士学位。师从我国著名心血管病专家徐成斌和胡大一教授。曾在北京大学人民医院心血管内科学习工作10年。2002年至2009年任北京电力医院副院长及心血管内科主任，2010年至2019年6月任首都医科大学附属北京天坛医院心血管内科主任，首都医科大学心脏病学系副主任。2019年7月任北京中医药大学东直门医院心血管科主任。长期从事心血管内科临床医疗和科研工作，擅长冠心病心肌梗死介入性诊断和治疗，以第一作者或通讯作者在国内外发表论文70余篇，主编或副主编学术专著10部。',
            "mediaUrl": "",
            "course":'老年人的心血管疾病'
        },
        {
            "id":'3-20',
            "headPortrait": "",
            "name": "孟晓萍",
            "unit": "长春中医药大学附属医院心血管内科心脏康复中心主任 ",
            "post": "教授、主任医师、硕士生导师、国家级专家；",
            "postInfo":'曾在美国Emory大学医学院进修，主要从事冠心病的基础与临床研究. 完成了三项由美国国家健康研究学会及两项心脏病研究学会资助的科研项目， 有13篇论文发表在美国权威医学期刊，曾经连续两届担任美国亚特兰大华人生命学会副会长，曾经四次获得教育部春辉计划资助回国讲学及学术交流。 现社会兼职：中国心脏联盟心血管疾病预防与康复学会主任委员，中国康复学会心血管病专业委员会副主任委员，中国老年学会心脑血管病专业委员会副主任委员，中国抗衰老促进会慢病防控工作委员会专家委员会副主任委员，国际动脉粥样硬化学会中国分会常务理事，吉林省慢病防控学术联盟主任委员等。',
            "mediaUrl": "",
            "course":'动脉粥样硬化怎么预防，怎么治？'
        },
        {
            "id":'3-21',
            "headPortrait": "",
            "name": "刘文玲",
            "unit": "北大人民医院  心血管内科",
            "post": "主任医师",
            "postInfo":'毕业于北京医科大学临床医学系，第四军医大学航空医学系 ，就职与民航总医院，中国国际航空公司航卫中心，从事临床医学40余年，航空医学十余年 ，全科医学十余年，是中国最美医生团队成员-中国志愿医生。',
            "mediaUrl": "",
            "course":'心血管疾病与遗传'
        },
        {
            "id":'3-22',
            "headPortrait": "",
            "name": "毕春强",
            "unit": "中国中医科学院广安门医院",
            "post": "骨科 副主任医师",
            "postInfo":'获院级中青年名中医、区级优秀青年人才荣誉称号。 科研学术: 主持或参与课题国家自然科学基金、市级及院级课题8项，在国内核心期刊发表论文20余篇。 社会兼职: 中华中医药学会外治分会第一届青年委员，中国民间中医医药研究开发协会骨伤分会常务理事',
            "mediaUrl": "",
            "course":'白领一族怎样预防颈椎病'
        },
        {
            "id":'3-23',
            "headPortrait": "",
            "name": "丁荣晶",
            "unit": "北大人民医院  心血管内科",
            "post": " 副主任医师",
            "postInfo":'心脏病个体化治疗，心力衰竭心肌康复治疗，冠心病血管康复治疗，心血管风险评估，心血管病人运动处方，不明原因胸痛，胸闷或心悸，难治性高血压，高血脂 北京大学人民医院心内科副主任医师，硕士研究生导师，心血管博士后,美国梅奥医学中心心血管专业访问学者，获美国心肺康复学会心脏康复专业人员资质认证（CCRP）。主要社会兼职：中国康复医学会心血管病委员会副主任委员,中国心脏联盟心血管预防康复委员会副主任委员，中华医学会心血管分会预防学组副组长,中华医学会心身医学分会双心学组副组长，北京医学会心肺康复专业委员会委员。《中华心血管病杂志》《实用内科杂志》《中国心理卫生杂志》《慢性病杂志》《四川精神卫生杂志》编委。从事心血管临床和重症救治工作22年，擅长心血管病风险预测综合优化治疗、双心疾病、心肌康复和血管康复治疗。在国家级核心期刊发表文章50余篇，SCI文章20余篇。参编、参译著作10余部，主编主译著作5部。主持国家自然科学基金、市科委、教育部等课题7项，获中华医学会科技进步三等奖1项，中国康复医学会科技进步二等奖 1项，实用新型专利3项。',
            "mediaUrl": "",
            "course":'心脏病能提前发现吗？有没有特别的症状'
        },
        {
            "id":'3-24',
            "headPortrait": http+"image/吴继敏.jpg",
            "name": "吴继敏",
            "unit": "火箭军特色医学中心",
            "post": " 胃食管反流病科主任",
            "postInfo":'师从中国胃食管气道反流疾病开拓者、中科院院士汪忠镐教授 中国医疗保健国际交流促进会胃食管反流多学科分会副主任委员兼秘书长 中国医师协会外科分会胃食管反流病诊疗专业委员会副主任委员 中华医学会消化病分会食管疾病协作组委员 中国中西医结合学会胃食管反流病专家委员会副主任委员 中国医疗保健国际交流促进会临床实用技术分会食管裂孔疝外科学组组长',
            "mediaUrl": http+"2-24.mkv",
            "course":'胃食管返流科普',
            "vId":'e3129xjc24b'
        },
        {
            "id":'3-25',
            "headPortrait": "",
            "name": "何方方",
            "unit": "北京协和医院 ",
            "post": " 主任医师教授  ",
            "postInfo":'1976年毕业于北京医学院，毕业后一直在北京协和医院妇产科工作，历任妇产科住院医师、总住院医师，1985年任主治医师，1993年任副主任医师，2000年晋升为主任医师。1999年被中国医学科学院研究生院聘为硕士研究生导师。1996年5月至1996年11月作为访问学者被世界卫生组织派往新加坡国立大学医院学习不育的临床诊断和治疗，1997年1月至1997年12月参加新加坡国立大学临床胚胎学硕士班并获新加坡国立大学临床胚胎学硕士学位。回国后筹建了协和医院辅助生育中心并获协和医院首例试管婴儿妊娠成功，填补了协和医院在辅助生育领域的空白。',
            "mediaUrl": "",
            "course":'优生优育的重要性'
        },
        {
            "id":'3-26',
            "headPortrait": http+"image/袁先道.jpg",
            "name": "袁先道",
            "unit": "首都医科大学附属北京安贞医院",
            "post": " 耳鼻喉科 副主任医师",
            "postInfo":'中国医学科学院/北京协和医学院医学临床博士毕业，耳鼻咽喉头颈外科副主任医师，一直从事专业临床工作20余年，美国芝加哥大学医学院耳鼻喉科和MD安德森肿瘤中心工作经历，有丰富的临床经验，擅长用最先进最适合的国际一流标准诊治耳鼻咽喉头颈外科常见病多发病及各种疑难重症，临床经验报道曾获美国全球最高级别的学术会议邀请并作演讲。',
            "mediaUrl": http+"2-26.mkv",
            "course":'慢性鼻炎慢性咽炎的认识和诊治误区',
            "vId":'u3129vn9htu'
        }
    ]
]
// 大咖访谈
const daKa=[
    {
        "id":'dk-0-1',
        "headPortrait": http+"image/dk02.jpg",
        "name": "辛利军",
        "unit": "京东集团",
        "post": "京东集团副总裁、京东健康CEO",
        "postInfo": "“互联网+”医疗健康，赋能医药产业创新发展",
        "vId":"m3128pfnd89",//小程序-id 视频
        "mediaUrl": http+"dk02.mp4"
    },
    {
        "id":'dk-0-2',
        "headPortrait": http+"image/dk01.jpg",
        "name": "Dr. Dinesh Nair",
        "unit": "",
        "post": "世界银行高级卫生专家",
        "postInfo": "“以价值为导向的医疗保障体系改革”国际经验分享",
        "vId":"l312893kdmf",//小程序-id 视频
        "mediaUrl": http+"dk01.mp4"
    },
    {
        "id":'dk-0-3',
        "headPortrait": http+"image/dk03.jpg",
        "name": "吴明",
        "unit": "",
        "post": "北京大学医学部主任助理,公共卫生学院卫生政策与管理系主任,中国卫生经济学会副会长",
        "postInfo": "医保支付方式改革，推动医疗产业变革与价值医疗发展",
        "vId":"j3128uy56u1",//小程序-id 视频
        "mediaUrl": http+"dk03.mp4"
    },
    {
        "id":'dk-0-4',
        "headPortrait": http+"image/dk04.png",
        "name": "陈秋霖",
        "unit": "",
        "post": "中国社科院健康业发展研究中心副主任",
        "postInfo": "医改背景下，多方参与加速商业健康创新",
        "vId":"j312812e2a7",//小程序-id 视频
        "mediaUrl": http+"dk04.mp4"
    },
    {
        "id":'dk-0-5',
        "headPortrait": http+"image/刘谦.jpg",
        "name": "刘谦",
        "unit": "",
        "post": "阿斯利康商业战略与卓越运营副总裁",
        "postInfo": "大数据驱动下，医药产业数字化营销转型",
        "vId":"p3129e78mtc",//小程序-id 视频
        "mediaUrl": http+"dk05.mp4"
    },
    {
        "id":'dk-0-6',
        "headPortrait": http+"image/金恩林.png",
        "name": "金恩林",
        "unit": "",
        "post": "京东健康医药部总经理兼战略与投资负责人",
        "postInfo": "医药电商创新助力医药产业营销变革",
        "vId":"b31290ylt1x",//小程序-id 视频
        "mediaUrl": http+"dk06.mp4"
    },
    {
        "id":'dk-0-7',
        "headPortrait": http+"image/周新元.png",
        "name": "周新元",
        "unit": "",
        "post": "京东健康渠道创新部总经理兼药京采负责人",
        "postInfo": '"互联网+"医药流通新变局',
        "vId":"d3129u8btkj",//小程序-id 视频
        "mediaUrl": http+"dk07.mp4"
    },
    {
        "id":'dk-0-8',
        "headPortrait": http+"image/郭小龙.png",
        "name": "郭小龙",
        "unit": "",
        "post": '一力制药股份公司副总经理',
        "postInfo": '智运快线创新打通乡村药品配送"最后一公里"',
        "vId":"k3129vgdln2",//小程序-id 视频
        "mediaUrl": http+"dk08.mp4"
    },
    {
        "id":'dk-0-9',
        "headPortrait": http+"image/dk09.jpg",
        "name": "刘晖、肖建波、王威、郝一鸣、汪鳌、喻君生",
        "unit": "",
        "post": '发挥数据与平台价值，赋能医药产业数字化营销转型，实现降本增效（圆桌会）',
        "postInfo": '',
        "vId":"v3129kth6nb",//小程序-id 视频
        "mediaUrl": http+"dk09.mp4"
    },
    {
        "id":'dk-0-10',
        "headPortrait":http+"image/唐潇青.jpg",
        "name": "唐潇青",
        "unit": "麦肯锡全球副董事会合伙人",
        "post": '',
        "postInfo": '',
        "vId":"n3129m5cpid",//小程序-id 视频
        "mediaUrl": http+"dk10.mp4",
        "course":"数字化医疗新趋势及对药企商业模式的影响"
    },
    {
        "id":'dk-0-11',
        "headPortrait": http+"image/杨建.jpg",
        "name": "杨建",
        "unit": "京东安联",
        "post": '副总裁',
        "postInfo": '',
        "vId":"g3129yfk0hj",//小程序-id 视频
        "mediaUrl": http+"dk11.mp4",
        "course":'以患者为中心，打造"互联网+医+药+险"服务闭环'
    },
    {
        "id":'dk-0-12',
        "headPortrait": http+"image/肖建波.png",
        "name": "肖建波",
        "unit": "京东健康互联网医院",
        "post": '医药部总经理',
        "postInfo": '',
        "vId":"m3129vc43ug",//小程序-id 视频
        "mediaUrl": http+"dk12.mp4",
        "course":'京东健康互联网医院如何助力医药流通企业'
    },
    {
        "id":'dk-0-13',
        "headPortrait": http+"image/dk13.png",
        "name": "陈明、黄雷声、杨建、张圣明、王亮、王立林",
        "unit": "",
        "post": '',
        "postInfo": '',
        "vId":"x31290m0zsm",//小程序-id 视频
        "mediaUrl": http+"dk13.mp4",
        "course":'"互联网+"医保商保创新,加速医药流通,实现患者周期管理(圆桌会议)'
    }
]
export {
    jsonData,
    vData,
    daKa
}